import * as React from "react";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

function SvgEdit(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          stroke="null"
          fill="#1E1E1E"
          d="M9.26474322,3.43506657 L13.5581608,7.72848416 L4.29341759,16.960946 L0,16.960946 L0,12.6675285 L9.26474322,3.43506657 Z M12.7086872,-4.92939023e-14 L17,4.29131285 L14.2836903,7.00762257 L9.99237743,2.71630973 L12.7086872,-4.92939023e-14 Z"
          id="Combined-Shape"
        ></path>
      </g>
    </SvgIcon>
  );
}

export default SvgEdit;
